<template>
    <div class="grid grid-cols-2 gap-2 lg:mr-24 text-xs sm:text-sm">
        <div class="flex gap-2 sm:gap-3 items-center">
            <div class="flex justify-center items-center p-1 rounded-lg bg-primary_blue bg-opacity-10">
                <component :is="props.icon" class="shrink-0 h-5 w-5 fill-primary_blue" />
            </div>
            <span class="text-neutral-500">
                {{ props.title }}
            </span>
        </div>
        <div v-if="props.value !== undefined" class="flex items-center text-neutral-800 pr-7">
            <p v-if="props.value !== null">
                {{ props.value }}
            </p>
            <p v-else>
                &ndash;
            </p>
        </div>
        <div class="flex items-center text-neutral-800 pr-7">
            <slot name="value" />
        </div>
    </div>
</template>

<script setup>
    import { Icons } from 'taxi-lib';

    const props = defineProps({
        icon: {
            type: Object,
            required: false,
            default: Icons.TIInvoice,
        },
        title: {
            required: true,
            default: null,
        },
        value: {
            required: false,
            default: undefined,
        },
    })
</script>